module.exports = __webpack_public_path__ + "static/media/miniGolf.52ea3d3e.png";